import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class FrontendTexts extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.

  static modelName = 'FrontendTexts'
  // Define default properties here
  static instanceDefaults () {
    return {
      content: null,
    }
  }
}
const servicePath = 'frontend-texts'
const servicePlugin = makeServicePlugin({
  Model: FrontendTexts,
  service: feathersClient.service(servicePath),
  servicePath,
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
})

export default servicePlugin
